import RandomNumberGenerator from "./RandomNumberGenerator"
import config from "../config.json"
import Logger from "./Logger"
export default class NumberGenerator {
  private cache: Record<string, number[]> = {}
  constructor(
    private readonly randomNumberGenerator: RandomNumberGenerator,
    private readonly logger: Logger,
  ) {}

  public generate(initialMe: number): number[] {
    if (this.cache[this.randomNumberGenerator.seed]) {
      return this.cache[this.randomNumberGenerator.seed]
    }

    let currentMe: number = initialMe
    const firstEnemy: number = this.getInitialEnemy(currentMe)
    const result: number[] = [firstEnemy]

    while (result.length < config.totalEnemies) {
      const prevIndex: number = result.length - 1

      result.push(this.nextEnemy(currentMe, result[prevIndex]))
      currentMe = this.nextMe(currentMe, result[prevIndex])
    }

    this.cache[this.randomNumberGenerator.seed] = result

    this.logger.log("[NumberGenerator] numbers:", result)

    return result
  }

  private getInitialEnemy(max: number): number {
    return this.randomNumberGenerator.randomInt(config.minEnemyValue, max)
  }

  private nextEnemy(me: number, currentEnemy: number): number {
    return this.randomNumberGenerator.randomInt(
      currentEnemy + 1,
      this.nextMe(me, currentEnemy),
    )
  }

  private nextMe(me: number, enemy: number): number {
    return Math.ceil((me + enemy) * config.sumGrowthCoefficient)
  }
}
